(() => {
  const wrapper = document.querySelector('.rb-cart-discount');
  if (!wrapper) return;

  const form = wrapper.querySelector('[data-discount-form]');
  const input = wrapper.querySelector('[data-discount-input]');
  const details = wrapper.querySelector('.rb-cart-discount__details');

  const focusInput = () => {
    if (!input) return;
    requestAnimationFrame(() => {
      input.focus({ preventScroll: true });
      input.select();
    });
  };

  if (details) {
    if (details.open) {
      focusInput();
    }

    details.addEventListener('toggle', () => {
      if (details.open) {
        focusInput();
      }
    });
  }

  if (!form) return;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const code = input?.value.trim();
    if (!code) return;

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: code,
          attributes: { discount_code: code }
        })
      });
      window.location.reload();
    } catch (error) {
      console.error('Discount apply error', error);
    }
  });

  document.addEventListener('click', async (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (!target.matches('[data-discount-remove]')) return;

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: '',
          attributes: { discount_code: '' }
        })
      });
      window.location.reload();
    } catch (error) {
      console.error('Discount remove error', error);
    }
  });
})();
